<template>
  <div class="back_wrapper">
    <div class="icon_view cur" @click="goBack"><van-icon name="arrow-left" size="18px" />返回</div>
    <slot>
      <img src="@/assets/images/scan_top.png" class="scan_icon" v-if="props.scan" @click="toScan" />
    </slot>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps({
  scan: {
    type: Boolean,
    default: false,
  },
  // 有些页面自定义返回页面
  backFn: {
    type: Function,
  },
});

function goBack() {
  if (props.backFn && typeof props.backFn === 'function') {
    props.backFn();
  } else {
    router.go(-1);
  }
}

const toScan = () => {
  let routerName = route.name;
  // 入菲复核页面点击扫码会进入到查菲页面
  if (routerName === 'reviewCode') {
    routerName = 'searchCode';
  }
  sessionStorage.setItem('scanEntrance', routerName);
  router.push('/enter/init');
};
</script>

<style scoped lang="scss">
.back_wrapper {
  min-height: 50px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  background-color: #fff;
  .icon_view {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 22px;
  }
  .scan_icon {
    width: 24px;
    margin-right: 4px;
  }
}
</style>
